if (!customElements.get('byjobes-personalization')) {
  customElements.define(
    'byjobes-personalization',
    class ByJobesPersonalization extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.error = this.querySelector('.byjobes-personalization__error');
        this.form = document.getElementById(this.input.getAttribute('form'));
        this.rules = this.querySelector('[data-byjobes-letter-rules]');
        this.letterRules = this.rules ? JSON.parse(this.rules.textContent) : {};

        if (!this.form) return;

        this.input.addEventListener('input', () => {
          if (this.dataset.kind !== 'name') this.input.value = this.input.value.toUpperCase();
          this.clearError();
        });
        this.form.addEventListener('submit', (event) => this.validate(event), true);
      }

      validate(event) {
        const value = this.input.value.trim();
        this.input.value = value;

        if (this.dataset.kind === 'name') {
          if (!value) this.reject(event, this.input.validationMessage);
          return;
        }

        if (!/^[A-Z]+$/.test(value)) {
          this.reject(
            event,
            this.dataset.kind === 'initial' ? this.dataset.invalidInitial : this.dataset.invalidLetters
          );
          return;
        }

        if (this.dataset.kind === 'initial' && value.length !== 1) {
          this.reject(event, this.dataset.invalidInitial);
          return;
        }

        if (this.dataset.kind === 'letters') {
          const variantId = this.form.querySelector('[name="id"]')?.value;
          const rule = this.letterRules[variantId];
          const validCount = rule && (rule.exact ? value.length === rule.count : value.length <= rule.count);
          if (!validCount) this.reject(event, this.dataset.countMismatch.replace('__COUNT__', rule?.count || 5));
        }
      }

      reject(event, message) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.input.setAttribute('aria-invalid', 'true');
        this.error.textContent = message;
        this.error.hidden = false;
        this.input.focus();
      }

      clearError() {
        this.input.removeAttribute('aria-invalid');
        this.error.hidden = true;
        this.error.textContent = '';
      }
    }
  );
}
